import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 140 104"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#e5e5e4",
      opacity: ".5"
    }, [
      _createElementVNode("path", { d: "M129.004 0H10.996A10.904 10.904 0 0 0 .125 10.871v82.225A10.904 10.904 0 0 0 10.996 104h118.008a10.905 10.905 0 0 0 10.871-10.904V10.871A10.906 10.906 0 0 0 129.004 0m5.752 90.22a8.66 8.66 0 0 1-8.628 8.629H13.873a8.66 8.66 0 0 1-8.63-8.629V13.748a8.66 8.66 0 0 1 8.63-8.63h112.255a8.66 8.66 0 0 1 8.628 8.63z" }),
      _createElementVNode("path", { d: "M96.683 41.42a5.41 5.41 0 0 0-8.548-.243L60.136 75.156a5.41 5.41 0 0 1-8.011.406L38.264 61.749a5.41 5.41 0 0 0-7.849.228l-20.41 22.75a5.363 5.363 0 0 0 4.03 8.921h110.207a5.36 5.36 0 0 0 4.372-8.498zM34.218 46.02c9.414 0 17.046-7.632 17.046-17.046s-7.632-17.047-17.046-17.047-17.046 7.632-17.046 17.047c0 9.414 7.631 17.046 17.046 17.046" })
    ], -1)
  ]))]))
}
export default { render: render }